import { render, staticRenderFns } from "./CustSetting.vue?vue&type=template&id=2b59b349&scoped=true"
import script from "./CustSetting.vue?vue&type=script&lang=js"
export * from "./CustSetting.vue?vue&type=script&lang=js"
import style0 from "./CustSetting.vue?vue&type=style&index=0&id=2b59b349&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b59b349",
  null
  
)

export default component.exports